import { Link } from "react-router-dom";
import type { MediaItem } from "@/lib/media";
import { categoryLabel, formatViews } from "@/lib/media";

interface MediaCardProps {
  item: MediaItem;
  showSynopsis?: boolean;
}

export default function MediaCard({ item, showSynopsis = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
          {categoryLabel(item.type)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1">
          {item.year} · {item.region} · {item.genres.join(" / ")}
        </p>
        {showSynopsis && (
          <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
            {item.synopsis}
          </p>
        )}
        <p className="text-xs text-foreground-400 flex items-center gap-1 mt-auto pt-1">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-fire-line"></i>
          </span>
          {formatViews(item.views)} 浏览
        </p>
      </div>
    </Link>
  );
}